import { Container, BrandsGrid, BrandCard } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

const brands = [
  "Warner Bros",
  "Discovery Kids",
  "Cartoon Network",
  "Pogo",
  "Spartan Manufacturing",
  "Big Trunk Communications",
  "Major IPC",
  "N.L. Dalmia Institute",
  "E-Z-Hook",
  "House of Toys",
  "Attero Recycling",
  "Vantage Nutrition"
];

export function Brands() {
  return (
    <Container id="brands">
      <h2>Brands I've Partnered With</h2>
      <BrandsGrid>
        {brands.map((brand, index) => (
          <ScrollAnimation animateIn="fadeInUp" delay={index * 50} key={index}>
            <BrandCard>
              {brand}
            </BrandCard>
          </ScrollAnimation>
        ))}
      </BrandsGrid>
    </Container>
  );
}
